<app-form-header class="backoffice-page-header"></app-form-header>
<mat-card>
  <div class="form-box" >
    <form [formGroup]="formularioAbs">

      <div class="container" fxLayout fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="10px" fxLayoutGap.xs="0">

        <mat-form-field appearance="outline">
          <mat-label>Código de Cliente</mat-label>
          <input matInput formControlName="codigoCliente" type="text" placeholder="Código de Cliente">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Cliente</mat-label>
          <input matInput formControlName="cliente" type="text" placeholder="Cliente">
        </mat-form-field>

      </div>

      <div class="container" fxLayout fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="10px" fxLayoutGap.xs="0">

        <mat-form-field appearance="outline">
          <mat-label>Número de Solicitud</mat-label>
          <input matInput formControlName="numeroSolicitud" type="text" placeholder="Número de Solicitud">
        </mat-form-field>

    <!--    <mat-form-field appearance="outline">
          <mat-label>Fecha de Solicitud</mat-label>
          <input matInput formControlName="fechaSolicitud" type="text" mask="d0/M0/0000"  placeholder="Fecha de Solicitud">
        </mat-form-field>-->

        <mat-form-field appearance="outline">
          <mat-label>Fecha de Solicitud</mat-label>
          <input matInput [matDatepicker]="picker"
                 datePickerFormat="DD/MM/YYYY HH:MM"
                 formControlName="fechaSolicitud" type="text" placeholder="Fecha de Solicitud">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

      </div>

      <div class="container" fxLayout fxLayout.xs="column" fxLayoutAlign="center" >
        <mat-form-field appearance="outline" class="full-wy">
          <mat-label>Comercio</mat-label>
          <input matInput formControlName="comercio" type="text" placeholder="Comercio" class="full-w">
        </mat-form-field>

      </div>

      <div class="container" fxLayout fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="10px" fxLayoutGap.xs="0">
        <mat-form-field appearance="outline">
          <mat-label>Monto Solicitado</mat-label>
          <input  matInput formControlName="montoSolicitado" type="text" mask="separator.0"  thousandSeparator="."  placeholder="Monto Solicitado">
        </mat-form-field>

        <app-finder-autocomplete class="autocomplete"  [dis]="dis" [columna]="['nombre']" [item]="f.estadoSolicitud.value" [service]="serviceEstadoSolicitud"
                                 placeHolder="Estado de Solicitud" (output)="f.estadoSolicitud.setValue($event);">
        </app-finder-autocomplete>

      </div>

      <div class="container" fxLayout fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="10px" fxLayoutGap.xs="0">


        <mat-form-field appearance="outline">
          <mat-label>Plazo en Meses</mat-label>
          <input type="number" matInput formControlName="plazoMeses" type="text" placeholder="Plazo en Meses">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Importe Cuota</mat-label>
          <input  matInput formControlName="importeCuota" type="text" mask="separator.0"  thousandSeparator="." placeholder="Importe Cuota">
        </mat-form-field>

      </div>

      <div class="container" fxLayout fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="10px" fxLayoutGap.xs="0">

        <mat-form-field appearance="outline">
          <mat-label>Monto Desembolsado</mat-label>
          <input matInput formControlName="montoDesembolsado" type="text" mask="separator.0"  thousandSeparator="." placeholder="Monto Desembolsado">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Mensaje</mat-label>
          <input matInput formControlName="mensajeAprobadoRechazado" type="text" placeholder="Mensaje">
        </mat-form-field>
      </div>

      <div class="form">
       <br>
        <!--<div class="button-box" *ngIf="!dis && editar">
          <app-form-actions (primaryEmiter)="guardar()" (acentEmiter)="cancelar()"
                            (warnEmiter)="eliminar(formularioAbs.value)" [hideBtnWarn]="!editar" [submitted]="submitted">
          </app-form-actions>
        </div>-->
        <!--<div class="button-box" *ngIf="!dis && editar">
          <app-form-actions (primaryEmiter)="guardar()" (acentEmiter)="cancelar()" [hideBtnAcent]="!editar"
                             [submitted]="submitted">
          </app-form-actions>
        </div>-->
        <div class="button-box" *ngIf="!dis && editar">
    <!--      <app-form-actions (primaryEmiter)="guardar()" (acentEmiter)="cancelar()" [hideBtnAcent]="true"
                            [hideBtnWarn]="!editar" [submitted]="submitted">
          </app-form-actions>-->

          <button mat-raised-button color="primary" (click)="guardar()">
            Guardar
          </button>

          <button mat-raised-button color="warn" (click)="cancelar()">
            Cancelar
          </button>

        </div>
      </div>
    </form>

  </div>
</mat-card>
